import { userConstants } from "../../constant";
export function nda(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_NDA:
      return action.NDA;
    
    case userConstants.GET_NDA_PACKAGES_LIST:
        return {
          ...state,
          packages: action.NDA_packages_list, // Add the packages to the state
    };
   
    default:
      return state;
  }
}
